import "core-js/modules/es.reflect.construct.js";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.array.concat.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/*----------------------------------------------------*/
// Dependencies

/*----------------------------------------------------*/
import { performance, register, attach } from './core';
import EventEmitter from './eventemitter';
/*----------------------------------------------------*/
// Constants & Variables

/*----------------------------------------------------*/

var INSTANCE;
var PLUGINS = [];
var defaults = {
  $: Object.create(null)
};
var properties = {
  debug: false,
  $html: null,
  $body: null,
  $window: null,
  bounds: Object.create(null),
  $: Object.create(null)
};
/*----------------------------------------------------*/
// Module

/*----------------------------------------------------*/

var Application = /*#__PURE__*/function (_EventEmitter) {
  _inherits(Application, _EventEmitter);

  var _super = _createSuper(Application);

  /**
     * Create the global controller of the application
     * @param {Object} constants application global constants
     * @param {Object} options instance options
     */
  function Application() {
    var _this;

    var constants = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Application);

    // singleton
    if (INSTANCE) return _possibleConstructorReturn(_this, INSTANCE);
    _this = _super.call(this);
    INSTANCE = _assertThisInitialized(_this); // properties && constants

    Object.assign(Application.prototype, properties, constants); // options

    _this.options = Object.assign(Object.create(null), defaults, options); // remove useless prototypes

    if (typeof Object.setPrototypeOf !== 'undefined') {
      Object.setPrototypeOf(_this.options, null);
      Object.setPrototypeOf(_this.options.$, null);
    } // debug


    return _possibleConstructorReturn(_this, _assertThisInitialized(_this));
  }

  _createClass(Application, [{
    key: "start",
    value: function start() {
      this.emit('beforeStart'); // attach plugins

      attach(PLUGINS, this);
      this.emit('start');
      return this;
    }
  }, {
    key: "ready",
    value: function ready() {
      this.emit('beforeReady'); // global dom elements

      this.$html = $d(document.documentElement);
      this.$body = $d(document.body);
      this.$window = $d(window); // refresh dom objects collection

      this.$select();
      this.bindEvents();
      this.emit('ready');
      return this;
    } // Application lifecycles
    //
    // created : initialize controller
    // destroy : destroy controller (and clear garbage)
    // enter : when app is in a ready state and things can be shown
    // leave : just before resolving a new route
    // --------------------------------------------------

  }, {
    key: "created",
    value: function created() {
      var _this2 = this;

      this.emit('created');
      var promise;

      if (typeof this.$dispatcher !== 'undefined') {
        promise = new Promise(function (resolve, reject) {
          _this2.$dispatcher.created().then(resolve).catch(reject);
        });
      } else {
        promise = Promise.resolve();
      }

      return promise;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.emit('destroy');

      if (typeof this.$dispatcher !== 'undefined') {
        this.$dispatcher.destroy();
      }
    }
  }, {
    key: "enter",
    value: function enter() {
      var _this3 = this;

      this.emit('enter');
      var promise;

      if (typeof this.$dispatcher !== 'undefined') {
        promise = new Promise(function (resolve) {
          _this3.$dispatcher.enter().then(resolve);
        });
      } else {
        promise = Promise.resolve();
      }

      return promise;
    }
  }, {
    key: "leave",
    value: function leave() {
      var _this4 = this;

      this.emit('leave');
      var promise;

      if (typeof this.$dispatcher !== 'undefined') {
        promise = new Promise(function (resolve) {
          _this4.$dispatcher.leave().then(resolve);
        });
      } else {
        promise = Promise.resolve();
      }

      return promise;
    } // Methods
    // --------------------------------------------------

  }, {
    key: "destroyAll",
    value: function destroyAll() {
      this.destroy();
      this.removeAllListeners();
      PLUGINS = [];
      INSTANCE = null;
    } // Events
    // --------------------------------------------------

  }, {
    key: "bindEvents",
    value: function bindEvents() {
      // emit global events
      this.emit('resize');
      this.emit('scroll'); // rAF on window events

      this.bounds.resize = this.onResize.bind(this);
      this.bounds.scroll = this.onScroll.bind(this);
      this.$window.on('resize', this.bounds.resize);
      this.$window.on('scroll', this.bounds.scroll);
    }
  }, {
    key: "unbindEvents",
    value: function unbindEvents() {
      this.$window.off('resize', this.bounds.resize);
      this.$window.off('scroll', this.bounds.scroll);
    }
  }, {
    key: "onResize",
    value: function onResize(e) {
      var _this5 = this;

      window.requestAnimationFrame(function () {
        return _this5.emit('resize', e);
      });
    }
  }, {
    key: "onScroll",
    value: function onScroll(e) {
      var _this6 = this;

      window.requestAnimationFrame(function () {
        return _this6.emit('scroll', e);
      });
    } // Helpers
    // --------------------------------------------------

  }, {
    key: "$select",
    value: function $select() {
      this.$ = this.$body.$select(this.options.$);
    } // Static methods
    // --------------------------------------------------

  }], [{
    key: "use",
    value: function use() {
      var module = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      register.apply(void 0, [PLUGINS, module].concat(args));
    }
  }]);

  return Application;
}(EventEmitter);

export default Application;

if (module.hot) {
  module.hot.accept(function (err) {
    if (err) {
      console.error(err);
    }
  });
}